import { useTranslation } from 'react-i18next';
import {
    EventAudienceCounts as AudienceCounts,
    EventType,
} from 'src/domain/event';

export const EventAudienceCounts = ({
    counts,
    eventType,
    isLoading = false,
    audience,
    descriptive = false,
}: {
    counts?: Partial<AudienceCounts>;
    eventType: EventType;
    isLoading?: boolean;
    audience?: 'residents' | 'mainContacts';
    descriptive?: boolean;
}) => {
    const { t } = useTranslation();
    const isRelativesEvent = audience
        ? audience === 'mainContacts'
        : eventType === EventType.relatives;
    const count = isRelativesEvent
        ? counts?.mainContactCount
        : counts?.residentCount;
    if (isLoading) {
        return (
            <div role="status" aria-label={t('common.loading')}>
                <div className="h-4 w-40 animate-pulse rounded bg-lightPeach" />
            </div>
        );
    }

    return (
        <div className="text-xs text-mongooseGray" aria-live="polite">
            {count === undefined
                ? t('modules.calendar.form.audienceCountUnavailable')
                : t(
                      isRelativesEvent
                          ? descriptive
                              ? 'modules.calendar.form.mainContactInvitationCount'
                              : 'modules.calendar.form.mainContactAudienceCount'
                          : 'modules.calendar.form.residentAudienceCount',
                      { count, value: count },
                  )}
        </div>
    );
};
